import React from "react";

export const Marquee = ({
  items = ["WRESTLING", "MUSIC", "EVENTS", "PORTO"],
  bg = "bg-kult-pink",
  color = "text-black",
  slow = false,
}) => {
  const sequence = Array.from({ length: 8 }).flatMap(() => items);
  return (
    <div
      className={`overflow-hidden border-y-2 border-black ${bg} ${color} py-3`}
      data-testid="marquee"
    >
      <div className={`marquee-track ${slow ? "marquee-slow" : ""}`}>
        {sequence.map((item, i) => (
          <span
            key={i}
            className="font-display text-2xl md:text-3xl tracking-tight px-6 flex items-center"
          >
            {item}
            <span aria-hidden className="px-6 text-xl">
              ⚡
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};
